import React, { useEffect } from 'react'
import {
    FormControl,
    Select,
    MenuItem,
    Typography,
    Box,
    CircularProgress,
} from '@mui/material'
import { usePatient } from '../contexts/PatientContext'
import { userAPI } from '../services/api'

const PatientSelector = () => {
    const {
        selectedPatient,
        patients,
        setPatients,
        loading,
        setLoading,
        updateSelectedPatient
    } = usePatient()

    useEffect(() => {
        const fetchPatients = async () => {
            try {
                setLoading(true)
                const response = await userAPI.getUsers()
                setPatients(response.data)
            } catch (error) {
                console.error('Error fetching patients:', error)
            } finally {
                setLoading(false)
            }
        }

        if (patients.length === 0) {
            fetchPatients()
        }
    }, [patients.length, setPatients, setLoading])

    const handlePatientChange = (event) => {
        const patientId = event.target.value
        const patient = patients.find(p => p.id === patientId)
        updateSelectedPatient(patient || null)
    }

    if (loading) {
        return (
            <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={20} />
                <Typography variant="body2" color="text.secondary">
                    Loading patients...
                </Typography>
            </Box>
        )
    }

    return (
        <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="body2" color="text.secondary">
                Patient:
            </Typography>
            <FormControl size="small" sx={{ minWidth: 200 }}>
                <Select
                    value={selectedPatient?.id || ''}
                    onChange={handlePatientChange}
                    displayEmpty
                    sx={{
                        backgroundColor: 'white',
                        '& .MuiSelect-select': {
                            py: 0.5,
                        }
                    }}
                >
                    <MenuItem value="">
                        <Typography variant="body2" color="text.secondary">
                            Select a patient
                        </Typography>
                    </MenuItem>
                    {patients.map((patient) => (
                        <MenuItem key={patient.id} value={patient.id}>
                            <Typography variant="body2">
                                {patient.name} ({patient.age}, {patient.sex})
                            </Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}

export default PatientSelector 